import { render, staticRenderFns } from "./epms1020_waste.vue?vue&type=template&id=cf9f1738&scoped=true"
import script from "./epms1020_waste.vue?vue&type=script&lang=js"
export * from "./epms1020_waste.vue?vue&type=script&lang=js"
import style0 from "./epms1020_waste.vue?vue&type=style&index=0&id=cf9f1738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9f1738",
  null
  
)

export default component.exports